import { Button, Col, Dropdown, MenuProps, Row, Typography } from 'antd';
import { DropdownButtonProps } from 'antd/es/dropdown';
import { ItemType } from 'antd/es/menu/interface';
import { memo } from 'react';

import { PrinterIcon } from 'assets/svg';
import { icons } from 'utils/constants/icons';

const { CaretDownOutlined } = icons;
const { Text } = Typography;

export const ExportOptionsButton = memo(
  ({ menu, ...passProps }: DropdownButtonProps) => {
    return (
      <Dropdown
        trigger={['click']}
        menu={menu}
        {...passProps}
        className={`border-solid border-[1px] rounded-[6px]`}
      >
        <Button
          size="middle"
          className="mt-[4px] py-0 px-0 border border-[#003056] h-[calc(100%-4px)] text-[#0066cc] [&>.ant-row>.item-right>.divider-y]:hover:bg-[#4096ff]"
        >
          <Row align={'middle'} className="h-full">
            <Col className="flex items-center gap-4 h-full px-[20px]">
              <PrinterIcon
                className={`printer-icon ${passProps.disabled && 'printer-icon:svg-'}`}
              />
              <Text className="leading-[19.6px] font-bold text-[#00538F]">
                Xuất
              </Text>
            </Col>
            <Col className="flex items-center h-full gap-[6px] px-[6px] item-right">
              <span className="h-full block w-[1px] bg-[#003056] divider-y"></span>
              <CaretDownOutlined className="text-[#00538F]" />
            </Col>
          </Row>
        </Button>
      </Dropdown>
    );
  },
);

// import { PrinterIcon } from 'assets/svg';
// import { icons } from 'utils/constants/icons';

type IItemType = {
  label: string;
  handleExport: () => void;
} & ItemType;

export type TMenuPropsCustom = {
  items: IItemType[];
} & Omit<MenuProps, 'items'>;

export type IExportOptionsButton = {
  menuProps: TMenuPropsCustom;
} & DropdownButtonProps;

// const { CaretDownOutlined } = icons;

// export const ExportOptionsButton = memo(
//   ({ menuProps, ...passProps }: IExportOptionsButton) => {
//     const [itemActive, setItemActive] = useState({} as IItemType);

//     const menuPropsCustom = useMemo(() => {
//       return {
//         ...menuProps,
//         items: menuProps.items.map((item, index) => {
//           if (index === 0) setItemActive(item);

//           const { handleExport, ...others } = item;
//           return { ...others, onClick: () => setItemActive(item) };
//         }),
//       } as MenuProps;
//     }, [menuProps]);

//     const handleOnClick = useCallback(() => {
//       itemActive.handleExport();
//     }, [itemActive]);

//     return (
//       <Dropdown.Button
//         menu={menuPropsCustom}
//         className={`mt-[4px] border-solid border-[1px] rounded-[6px]`}
//         // className={`mt-[4px] border-solid border-[1px] rounded-[6px] ${passProps.disabled && 'bg-[#c2c2c2]'}`}
//         icon={<CaretDownOutlined className="text-[#00538F]" />}
//         buttonsRender={([leftButton, rightButton]) => [
//           React.cloneElement(leftButton as ReactElement, {
//             className:
//               'rounded-l-md border-r border-[#00538F] p-0 h-auto w-[147px]',
//           }),
//           React.cloneElement(rightButton as ReactElement, {
//             className: 'rounded-r-md border-l border-[#00538F] p-0 h-auto',
//           }),
//         ]}
//         onClick={handleOnClick}
//         {...passProps}
//       >
//         <Row
//           gutter={[10, 0]}
//           justify={'start'}
//           align={'middle'}
//           className="py-[8px] px-[20px]"
//         >
//           <Col>
//             <PrinterIcon
//               className={`printer-icon ${passProps.disabled && 'printer-icon:svg-'}`}
//             />
//           </Col>
//           <Col>
//             <p
//               className="leading-[19.6px] font-bold text-[#00538F]"
//               // className={`leading-[19.6px] font-bold text-[#00538F] ${passProps.disabled && 'text-[white]'}`}
//             >
//               {itemActive.label}
//             </p>
//           </Col>
//         </Row>
//       </Dropdown.Button>
//     );
//   },
// );

// const menuProps: MenuProps = useMemo(() => {
//     return {
//       items: [
//         {
//           label: 'Xuất excel',
//           key: '1',
//           handleExport: () => console.log('Xuất excel'),
//         },
//         {
//           label: 'Xuất PDF',
//           key: '2',
//           handleExport: () => console.log('Xuất PDF'),
//         },
//         {
//           label: 'In',
//           key: '3',
//           handleExport: () => console.log('In'),
//         },
//       ],
//     };
//   }, []);
